import React from 'react'
import Wave from '../vectors/wave.svg'

const Banner = (props) => (
    <div className={`wave-wrapper-${props.dir}`}>
        <div className="gradient-bg"></div>
        <Wave />
    </div>
)

export default Banner
